import { IonButton } from "@ionic/react";
import React from "react";

interface EmptyStateProps {
  filterType: string;
  selectedProfileId: number | null;
  userProfileId?: number;
  onCreatePost: () => void;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  filterType,
  selectedProfileId,
  userProfileId,
  onCreatePost,
}) => {
  // Determine the empty state type
  const isViewingOwnProfile = selectedProfileId === userProfileId;
  const isMyPostsFilter = filterType === "Me" || isViewingOwnProfile;
  const isFollowersFilter = filterType === "followers";
  const showCreateButton =
    filterType === "Me" || (!selectedProfileId && !isFollowersFilter);
  const anotherUserProfile =
    selectedProfileId && selectedProfileId !== userProfileId;

  // Get appropriate text
  const getTitle = () => {
    if (isFollowersFilter) return "No posts from your network";
    if (anotherUserProfile) return "No reflections yet";
    if (isMyPostsFilter) return "No reflections yet";
    return "Take a moment to reflect";
  };

  const getDescription = () => {
    if (anotherUserProfile) {
      return "This user hasn't shared any reflections yet.";
    }
    if (isFollowersFilter) {
      return "Posts from people you follow will appear here. Start following others to see their reflections!";
    }
    if (isMyPostsFilter) {
      return anotherUserProfile
        ? "This user hasn't shared any reflections yet."
        : "Share your thoughts, feelings, and progress. Your first reflection is just a tap away!";
    }
    return "Write down your thoughts, feelings, progress toward your airway clearance goals. Small reflections can help you recognize what’s working, stay motivated, and celebrate each step forward.";
  };

  return (
    <div className="flex bg-white items-center justify-center min-h-[400px] px-4 py-12">
      <div className="w-full max-w-md">
        {/* Animated icon container */}
        {/* <div className="relative mb-6">
          <div className="absolute inset-0 flex items-center justify-center">
            <div
              className="w-32 h-32 rounded-full opacity-20 blur-2xl"
              style={{
                background:
                  "radial-gradient(circle, #0778CF 0%, transparent 70%)",
              }}
            />
          </div>
        </div> */}

        {/* Content */}
        <div className="text-center space-y-4">
          <h3
            className="text-2xl font-bold tracking-tight"
            style={{ color: "#0778CF" }}
          >
            {getTitle()}
          </h3>

          <p className="text-base text-gray-600 leading-relaxed px-4">
            {getDescription()}
          </p>

          {/* Action button */}
          {showCreateButton && (
            <div className="pt-4">
              <IonButton
                className=" h-12 text-white"
                style={{
                  "--border-radius": "24px",
                  "--background": "#00b0ca",
                }}
                onClick={onCreatePost}
              >
                Create your First reflection
              </IonButton>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
